import React from 'react'
import SequenceContainer from './SequenceContainer'

const SequencesContainer = ({ session, results, instances, selectedName }) => {
    //Isolation du channel fixe
    const fixedElement = session.data.mcCriterias.find(criteria => criteria.isFixed === true);   
    return (
        <div>
            {results.map((result, i) => (
                <SequenceContainer
                    key={i}
                    id={i + 1}
                    result={result}
                    results={results}
                    session={session}
                    attributes={session.metadata.attributes}
                    sequenceData={session.data.sequences.find(sequence => sequence.id === result.sequence.id)}
                    selectedName={selectedName}
                    fixedElement={fixedElement}
                />
            )
            )}
        </div>
    )
}

export default SequencesContainer
